class Language {
  getDefault() {
    return import.meta.env.VITE_DEFAULT_LANGUAGE;
  }
}

export default new Language();
